import { Feature } from 'ol';
import LineString from 'ol/geom/LineString';
import { TrackEntity } from '@/TrackEntity';
import { Ordered } from './OrderHelper';
import { Coordinate } from 'ol/coordinate';
import _ from 'lodash';

export default class TrackLineFeature extends Feature<LineString> implements Ordered {
    track: TrackEntity
    order: number // should be set by TrackEntity.addSegment. If it's ever found to still be -1, something's gone wrong.
    constructor(geometryOrProperties: LineString, track: TrackEntity, order: number) {
        super(geometryOrProperties)
        this.track = track
        this.order = order
        
    }

    setGeometry(geometry: LineString | undefined): void {
        if(geometry) {
            const coords = geometry.getCoordinates()
            if(_.some(coords, c => c.length === 3 && (c[2] === null || c[2] === undefined))) {
                coords.forEach(c => c.splice(2))
                geometry.setCoordinates(coords, geometry.getLayout())
            }
            super.setGeometry(geometry)
        }
    }

    getGeometry(): LineString {
        return super.getGeometry()!
    }

    setCoordinate(index: number, coord: Coordinate) {
        const geometry = this.getGeometry()!
        const coords = geometry.getCoordinates()
        coords[(index < 0 ? coords.length : 0) + index] = coord
        this.setGeometry(new LineString(coords, geometry.getLayout()))
    }
}